import Vue from 'vue'
import bus from '../bus'

const debug = true

const fullCollection = ({ api, endpoint, fetchOn = [] } = {}) => {
  fetchOn.push(endpoint + '.*')

  return new Vue({
    data () {
      return {
        all: [],
        params: {},
        fetching: true
      }
    },
    computed: {
      loading () {
        return this.fetching
      }
    },
    methods: {
      async fetch (params = null) {
        this.fetching = true
        if (params) this.params = params
        try {
          if (debug) console.log('[vue-repository] ' + endpoint + '/fullCollection fetching', this.params)
          if (typeof params === 'string') {
            this.all = (await api.get(endpoint + '?' + this.params.replaceAll('?', ''))).data
          } else {
            this.all = (await api.get(endpoint, this.params)).data
          }
        } finally {
          this.fetching = false
        }
      },
      purge () {
        this.all = []
      },
      destroy () {
        this.purge()
        this.$destroy()
      }
    },
    created () {
      if (debug) console.log('[vue-repository] ' + endpoint + '/fullCollection created')
      for (let event of fetchOn) {
        bus.on(event, this.fetch)
      }
    },
    destroyed () {
      if (debug) console.log('[vue-repository] ' + endpoint + '/fullCollection destroyed')
      for (let event of fetchOn) {
        bus.off(event, this.fetch)
      }
    }
  })
}

export default ({ api, endpoint }) => {
  return {
    methods: {
      createFullCollection (options = {}) {
        return fullCollection({ api, endpoint, ...options })
      }
    }
  }
}